export const UserRolesKey = {
  ADMIN: "admin",
  REDLINING_USER: "redlining_user",
  CLAUSE_CHECK_USER: "clause_check_user",
};

export const UserRoleTagLine = {
  [UserRolesKey.REDLINING_USER]: " Access Only Contract Redlining",
  [UserRolesKey.CLAUSE_CHECK_USER]: " Access only Clause Check",
  [UserRolesKey.ADMIN]: "Access to Clause Check & Contract Redlining",
};

export const PromptsForFeature = {
  CONTRACT_REVIEW: "contract_review",
  CLAUSE_CHECK: "clause_check",
  TALK_TO_CONTRACT: "talk_to_contract",
};

export const PromptLabels = [
  {
    value:
      "   Users can edit the threshold values pertaining to the rules for the below standard clauses.",
  },
  {
    value:
      "Users can manage keywords and their synonyms utilized by the chatbot for document queries.",
  },
];

export const defaultClauseStatus = {
  NEW_KEYWORD: "new",
  DEFAULT: "default",
};

export const rulesAndThresholds: { [key: string]: any } = {
  "Committed Buffer": {
    rules: [
      {
        startString:
          "For Bench Pool, Staffing levels are adjustable, with at least ",
        endString:
          " of the required personnel available to maintain service continuity, would be kept in buffer in case of extra resource needed.",
      },
    ],
    threshold: [
      {
        key: "Staffing Size/Bench Pool:",
        value:
          "Minimum percentage of required personnel to maintain service continuity.",
      },
    ],
  },
  "Productivity Improvements": {
    rules: [
      {
        startString: "The contract should exceed a term of ",
        endString: "starting from the SOW Effective Date.",
      },
      {
        startString: "The floor for productivity improvements is ",
        endString:
          "which represents the minimum permissible percentage increase in productivity.",
      },
    ],
    threshold: [
      {
        key: "Contract Term:",
        value: "Minimum duration for the contract term.",
      },
      {
        key: "Productivity Improvement (%):",
        value: "Minimum permissible percentage increase in productivity",
      },
    ],
  },
  "SLA Penalty/Earn back": {
    rules: [
      {
        startString: "The Credit cap /Penalty should be minimum ",
        endString: "",
      },
    ],
    threshold: [
      {
        key: "Credit Cap/Penalty:",
        value: "Minimum percentage for the credit cap or penalty.",
      },
    ],
  },
  "Volume Discounts": {
    rules: [
      {
        startString: "The total spend must be at ",
        endString: "MTC.",
      },
      {
        startString: "The volume discount should be a minimum of ",
        endString: "",
      },
    ],
    threshold: [
      {
        key: "Total Discount:",
        value: "Minimum Percentage discount applied to the total spend (MTC).",
      },
      {
        key: "Total Spends:",
        value: "Minimum MTC value required to qualify for the discount.",
      },
    ],
  },
};

export const defaultSynonyms = `Word: "SLA Penalties/Earn Back"
       Synonyms: "Service Level Agreement", "SLA", "Credit Cap", "Service Credit Allocation", "Earn Backs"
       Word: "Volume Discounts"
       Synonyms: "Volume Discounts", "Rebate, "Eligible "fees", "Discounts", "Discount Percentages"
       Word: "Non-EPP Investments"
       Synonyms: "Investment"
       Word: "Overtime/On-call & Holiday Bill Rates"
       Synonyms: "Overtime", "Rates", "Billing", "Billable Hours"
       Word: "Productivity Improvements"
       Synonyms: "Productivity", "Productivity Improvements", "Productivity Enhancements"
       Word: "Committed Buffer/Bench Pool"
       Synonyms: "Buffer Pool", "Personnel Management", "Bench", "Pool", "Committed Buffer"
       Word: "Economic Change Adjustment"
       Synonyms: "Economic Change Adjustment", "Cost Of Living Adjustment", "Economic Change", "Consumer Price Index", "ECA", "COLA", "CPI"
       Word: "Rate Card"
       Synonyms: "Role", "level", "Rates"`;

export const errorsForTTCClauseManagement = {
  WORD: {
    required: "Keword is required",
    duplicate: "keyword already exists",
  },
  SYNONYM: {
    minCharacters: "Synonym should be atleast 1 character",
    required: "Atleast one synonym is required",
    duplicate: "Synonym already exists for this keyword",
  },
};

export const defaultVisibleSynonymsNumber = 7;
